/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface SearchResultItem
 */
export interface SearchResultItem {
    /**
     * 
     * @type {string}
     * @memberof SearchResultItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultItem
     */
    subTitle?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchResultItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SearchResultItem
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchResultItem
     */
    lng?: number;
    /**
     * 
     * @type {Array<SearchResultItem>}
     * @memberof SearchResultItem
     */
    items?: Array<SearchResultItem>;
}

/**
 * Check if a given object implements the SearchResultItem interface.
 */
export function instanceOfSearchResultItem(value: object): boolean {
    return true;
}

export function SearchResultItemFromJSON(json: any): SearchResultItem {
    return SearchResultItemFromJSONTyped(json, false);
}

export function SearchResultItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'subTitle': json['subTitle'] == null ? undefined : json['subTitle'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SearchResultItemFromJSON)),
    };
}

export function SearchResultItemToJSON(value?: SearchResultItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'subTitle': value['subTitle'],
        'tags': value['tags'],
        'lat': value['lat'],
        'lng': value['lng'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SearchResultItemToJSON)),
    };
}

